import * as React from 'react';
import { SVGProps } from 'react';
const SvgPhone = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7375 12.0877L14.3162 14.509C13.5385 14.2775 12.0874 13.7513 11.1677 12.8316C10.248 11.9119 9.7219 10.4608 9.49039 9.68319L11.9117 7.26188L6.21463 1.56445L2.61687 5.16257C2.217 5.56244 1.99181 6.11173 2.00023 6.6726C2.02443 8.17106 2.42114 13.3757 6.52295 17.4775C10.6248 21.5793 15.8294 21.9749 17.3289 22.0002C17.3341 22.0002 17.3531 22.0002 17.3583 22.0002C17.9139 22.0002 18.439 21.7813 18.8368 21.3835L22.4356 17.7847L16.7375 12.0877ZM17.3478 19.8946C16.0346 19.8725 11.5413 19.52 8.01088 15.9885C4.46889 12.4465 4.12584 7.93745 4.1048 6.6505L6.21463 4.54067L8.93584 7.26188L7.57524 8.62249C7.32374 8.87293 7.21641 9.23492 7.28901 9.58217C7.31427 9.70318 7.93196 12.5728 9.67875 14.3196C11.4255 16.0664 14.2951 16.684 14.4161 16.7093C14.7666 16.784 15.1254 16.6756 15.3758 16.4241L16.7375 15.0635L19.4587 17.7847L17.3478 19.8946Z"
      fill="current"
    />
  </svg>
);
export default SvgPhone;
